import React from 'react';
import {Modal, Typography, Divider, Space, Card, Timeline, Row, Col} from 'antd';

const { Title, Text } = Typography;

const CashTrackingSessionModal = ({ visible, onClose, sessionData }) => {
    // Форматирование даты
    const formatDate = (dateString) => {
        try {
            const date = new Date(dateString);
            const months = [
                'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
                'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
            ];

            const day = date.getDate();
            const month = months[date.getMonth()];
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');

            return `${day} ${month} в ${hours}:${minutes}`;
        } catch (error) {
            console.error('Ошибка форматирования даты:', error);
            return 'Дата не определена';
        }
    };

    // Форматирование даты для timeline
    const formatTimelineDate = (dateString) => {
        try {
            const date = new Date(dateString);
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');

            return `${day}.${month}.${year} в ${hours}:${minutes}`;
        } catch (error) {
            console.error('Ошибка форматирования даты:', error);
            return 'Дата не определена';
        }
    };

    // Получение типа активности
    const getActivityTypeName = (type) => {
        const types = {
            'start_tracking': 'Начало сессии трекинга',
            'added_cash': 'Вложение наличных',
            'removed_cash': 'Изъятие наличных',
            'stop_tracking': 'Конец сессии трекинга'
        };
        return types[type] || type;
    };

    if (!sessionData) {
        return null;
    }

    return (
        <Modal
            title="Сессия трекинга наличных"
            open={visible}
            onCancel={onClose}
            footer={null}
            width={450}
            centered
            style={{ height: '600px' }}
            bodyStyle={{
                height: '500px',
                overflowY: 'auto',
                overflowX: 'hidden'
            }}
        >
            <div style={{maxHeight: '500px', overflowY: 'auto', overflowX: 'hidden'}}>
                <Space direction="vertical" size="large" style={{width: '100%'}}>
                    <div>
                        {/* Дата обновления */}
                        <Text type="secondary" style={{fontSize: '14px'}}>
                            {formatDate(sessionData.session.opened_at)}
                        </Text>
                        {/* Информация о кассе и смене */}
                        <Space direction="vertical" size="small" style={{width: '100%'}}>
                            <Text type="secondary" style={{fontSize: '14px'}}>
                                ID кассы: {sessionData.session.register_id},
                                ID смены: {sessionData.session.id}
                            </Text>
                        </Space>
                    </div>

                    <div>
                        {sessionData.session.status === 'closed' ? (
                            <>
                                <Title level={3} style={{margin: 0, fontSize: '24px', fontWeight: 600}}>
                                    Сессия закрыта
                                </Title>
                                <Text type="secondary" style={{fontSize: '14px'}}>
                                    {formatDate(sessionData.session.closed_at)}
                                </Text>
                            </>
                        ) : (
                            <>
                                <Title level={3} style={{margin: 0, fontSize: '24px', fontWeight: 600}}>
                                    {parseFloat(sessionData.total_amount).toLocaleString()} ₸
                                </Title>
                                <Text type="secondary" style={{fontSize: '14px'}}>
                                    Ожидаемый баланс наличных
                                </Text>
                            </>
                        )}
                    </div>

                    <Card
                        size="small"
                        bordered={false}
                        style={{backgroundColor: 'var(--ant-color-fill-tertiary)'}}
                    >
                        <Space direction="vertical" size="small" style={{width: '100%'}}>
                            <Space direction="vertical" size="small" style={{width: '100%'}}>
                                <Space style={{width: '100%', justifyContent: 'space-between'}}>
                                    <Text style={{fontSize: '14px'}}>
                                        Сумма закрытия пред. смены
                                    </Text>
                                    <Text style={{fontSize: '14px', fontWeight: 500}}>
                                        {parseFloat(sessionData.session.previous_closing_amount).toLocaleString()} ₸
                                    </Text>
                                </Space>
                                <Space style={{width: '100%', justifyContent: 'space-between'}}>
                                    <Text style={{fontSize: '14px'}}>
                                        Сумма при открытии смены
                                    </Text>
                                    <Text style={{fontSize: '14px', fontWeight: 500}}>
                                        {parseFloat(sessionData.session.opening_actual).toLocaleString()} ₸
                                    </Text>
                                </Space>
                                {sessionData.session.closing_actual && (
                                <Space style={{width: '100%', justifyContent: 'space-between'}}>
                                    <Text style={{fontSize: '14px'}}>
                                        Сумма при закрытии смены
                                    </Text>
                                    <Text style={{fontSize: '14px', fontWeight: 600}}>
                                        {parseFloat(sessionData.session.closing_actual).toLocaleString()} ₸
                                    </Text>
                                </Space>
                                )}
                                {sessionData.session.discrepancy && (
                                <Space style={{width: '100%', justifyContent: 'space-between'}}>
                                    <Text style={{fontSize: '14px'}}>
                                        Расхождение при закрытии смены
                                    </Text>
                                    <Text style={{fontSize: '14px', fontWeight: 600}}>
                                        {parseFloat(sessionData.session.discrepancy).toLocaleString()} ₸
                                    </Text>
                                </Space>
                                    )}
                            </Space>
                        </Space>
                    </Card>

                    {/* Платежи наличными */}
                    {sessionData.cash_transactions && (
                        <Card
                            size="small"
                            bordered={false}
                            style={{backgroundColor: 'var(--ant-color-fill-tertiary)'}}
                        >
                            <Space direction="vertical" size="small" style={{width: '100%'}}>
                                <Text type="secondary" style={{fontSize: '16px', fontWeight: 500}}>
                                    Платежи наличными
                                </Text>

                                <Divider style={{margin: '8px 0'}}/>

                                <Space direction="vertical" size="small" style={{width: '100%'}}>
                                    {/* Валовые платежи */}
                                    <Space style={{width: '100%', justifyContent: 'space-between'}}>
                                        <Text style={{fontSize: '14px'}}>
                                            Продажи
                                        </Text>
                                        <Text style={{fontSize: '14px', fontWeight: 500}}>
                                            {parseFloat(sessionData.cash_transactions.sales_sum).toLocaleString()} ₸
                                        </Text>
                                    </Space>

                                    {/* Возвраты */}
                                    <Space style={{width: '100%', justifyContent: 'space-between'}}>
                                        <Text style={{fontSize: '14px'}}>
                                            Возвраты
                                        </Text>
                                        <Text style={{fontSize: '14px', fontWeight: 500}}>
                                            {parseFloat(sessionData.cash_transactions.refunds_sum).toLocaleString()} ₸
                                        </Text>
                                    </Space>

                                    {/* Чистые платежи */}
                                    <Space style={{width: '100%', justifyContent: 'space-between'}}>
                                        <Text style={{fontSize: '14px'}}>
                                            Чистые платежи
                                        </Text>
                                        <Text style={{fontSize: '14px', fontWeight: 600}}>
                                            {parseFloat(sessionData.cash_transactions.net_sum).toLocaleString()} ₸
                                        </Text>
                                    </Space>
                                </Space>
                            </Space>
                        </Card>
                    )}

                    {/* История активности */}
                    {sessionData.cash_activity && sessionData.cash_activity.length > 0 && (
                        <Card
                            size="small"
                            bordered={false}
                            style={{backgroundColor: 'var(--ant-color-fill-tertiary)'}}
                        >
                            <Timeline
                                mode="left"
                                items={sessionData.cash_activity.map((activity) => ({
                                    children: (
                                        <Row justify="space-between" align="top">
                                            <Col flex="auto">
                                                <Space direction="vertical" size={0}>
                                                    <Text strong style={{fontSize: 14}}>
                                                        {getActivityTypeName(activity.type)}
                                                    </Text>
                                                    <Text type="secondary" style={{fontSize: 12}}>
                                                        {activity.note}
                                                    </Text>
                                                    <Text type="secondary" style={{fontSize: 12}}>
                                                        {activity.cashier_name} ({activity.cashier_id}), {formatTimelineDate(activity.created_at)}
                                                    </Text>
                                                </Space>
                                            </Col>
                                            <Col>
                                                <Text strong style={{fontSize: 14, whiteSpace: 'nowrap'}}>
                                                    {activity.amount ? `${parseFloat(activity.amount).toLocaleString()} ₸` : ''}
                                                </Text>
                                            </Col>
                                        </Row>
                                    ),
                                }))}
                            />
                        </Card>
                    )}
                </Space>
            </div>
        </Modal>
    );
};

export default CashTrackingSessionModal;